export const DS_CSS_VAR_PREFIX = '--ds';
